export default "__VITE_PUBLIC_ASSET__229be8d0__"